var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasErrors)?_c('v-alert',{attrs:{"type":"error","dismissible":"","prominent":""}},[_vm._v("\n\t"+_vm._s(_vm.$t("title.something_went_wrong"))+"\n\t"),_c('ul',_vm._l((_vm.errors),function(error,key){return _c('li',{key:key},[_vm._v(_vm._s(error))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }